import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=3867ccad&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3867ccad')) {
      api.createRecord('3867ccad', component.options)
    } else {
      api.reload('3867ccad', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=3867ccad&", function () {
      api.rerender('3867ccad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/offershelp.vue"
export default component.exports